import { Typography } from "@material-ui/core"
import dayjs from "dayjs"
import { useEffect, useMemo, useState } from "react"
import { Get } from "../../../../actions"
import { getTranslation } from "../../../../heplers/translationHelper";

export const BlockAccess=({reservationDate,isAdmin,children})=>{
          const [stopStatus,setStopStatus]=useState("ok")
    useEffect(()=>{
       Get({
                 targetDate:dayjs(reservationDate,"YYYY-MM-DD").format()
               },
               "ReservationStop/GetStopReservationStatus",
               null,
               resp=>{
                 setStopStatus(resp.data)
             },
               error=>{
                setStopStatus("stopped")
       
               }
             )
    },[reservationDate])
if(stopStatus=="ok" || isAdmin)
    return <> {children}</>
return <Typography>{getTranslation("Reservations for this date are blocked, please contact us at this email")}{" "}</Typography>
}